import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createShowroom,
  getShowroom,
  getShowrooms,
  editShowroom,
  deleteShowroom,
  getShowroomBySlug,
} from "api/showroomApi"

export const SHOWROOM_QUERY_KEY = "showrooms"

export const useShowrooms = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [SHOWROOM_QUERY_KEY, params],
    queryFn: () => getShowrooms(params),
    keepPreviousData: true,
    enabled,
  })
}

export const useShowroom = id => {
  return useQuery({
    queryKey: [SHOWROOM_QUERY_KEY, id],
    queryFn: () => getShowroom(id),
    enabled: !!id,
  })
}

export const useShowroomBySlug = slug => {
  return useQuery({
    queryKey: [SHOWROOM_QUERY_KEY, "slug", slug],
    queryFn: () => getShowroomBySlug(slug),
    enabled: !!slug,
  })
}

export const useCreateShowroom = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createShowroom,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([SHOWROOM_QUERY_KEY])
      }
    },
  })
}

export const useEditShowroom = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editShowroom,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([SHOWROOM_QUERY_KEY])
      }
    },
  })
}

export const useDeleteShowroom = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteShowroom,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([SHOWROOM_QUERY_KEY])
      }
    },
  })
}
